import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Footer from "../Footer";
import BottomBarIcons from "../BottomBarIcons";
import useGetClientId from "../../hooks/useGetClientId";
import http from "../../api/server";
import {
  GET_ALL_INSPECTION_MASTER,
  DELETE_PROPERTY_INSPECTION,
} from "../../api/apiPath";
// import { hostName } from "../../config/config";

import Header from "../Header";
import Sidebar from "../Sidebar";
import NewDynamicTable from "../common/NewDynamicTable";
import Toaster from "../common/Toaster";
import ConfirmationPopup from "../common/ConfirmationPopup";
import InspectionTile from "./InspectionTile";
import { Statuses } from "../common/constant";

import { Box, IconButton, Chip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DatePicker from "react-multi-date-picker";
import ClearIcon from "@mui/icons-material/Clear";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import SidebarIcons from "../SidebarIcons";
// import HistoryIcon from '@mui/icons-material/History';
// import { InputAdornment, TextField } from "@mui/material";
// import { sampleInspectorRows } from "../common/constant";

const Inspections = () => {
  const { clientNameParam } = useParams();
  const { userObj } = useSelector((state) => state.user);
  const [allPropertyList, setAllPropertyList] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [hideSidebar, setHideSidebar] = useState(true);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState({});
  const navigate = useNavigate();
  const [toolbar, setToolBar] = useState({
    searchText: "",
    propertyName: "Property Name",
    inspector: "Inspector",
    status: "Status",
  });

 


  const [dateRange, setDateRange] = useState([null, null]);
  const [inspectorOptions, setInspectorOptions] = useState([]);

 const isAnyFilterApplied =
  toolbar.searchText !== "" ||
  toolbar.propertyName !== "Property Name" ||
  toolbar.inspector !== "Inspector" ||
  dateRange[0] !== null ||
  dateRange[1] !== null ||
  toolbar.status !== "Status";
  const clientObj = useGetClientId();

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };
  const closePopup = () => {
    setShowConfirmationPopup(false);
  };

  useEffect(() => {
    if (clientObj.clientId) {
      handleGetAllPropertyByClinetID(clientObj.clientId);
      //setAllPropertyList(sampleInspectorRows);
    }
  }, [clientObj.clientId, clientObj.loading]);

  const handleGetAllPropertyByClinetID = async (clientId) => {
    try {
      const response = await http.get(
        GET_ALL_INSPECTION_MASTER + "?ClientId=" + clientId
      );
      if (response.status === 200) {
        const tempArr = [];
        let tempInsp = [];
        response?.data.map((inspection) => {
          const inspectorsArr = inspection.assignedInspectors.map(
            (item) => item.inspectorName
          );
          const newObj = {
            id: inspection.inspectionMasterId,
            propertyMasterId: inspection.properties[0]?.propertyMasterId,
            propertyName: inspection.properties[0]?.propertyName,
            inspector: inspectorsArr.join(", "),
            date: new Date(inspection.approvalDueDate).toLocaleDateString(
              "en-GB"
            ),
            CreatedDate: new Date(inspection.createdDate).toLocaleDateString(
              "en-GB"
            ),
            status: inspection.status,
            inspectionMasterId: inspection.inspectionMasterId,
            inspectionRefNumber: inspection.inspectionReferenceNumber,
            inspectionDate: inspection.scheduledInspectionDate ? new Date(inspection.scheduledInspectionDate).toLocaleDateString("en-GB") : "N/A"
          };
          tempInsp = [...tempInsp, ...inspectorsArr];
          tempArr.push(newObj);
        });
        console.log("response.data", response.data, tempArr);
        setAllPropertyList(tempArr);
        setInspectorOptions(tempInsp);
      }
    } catch (error) {
      return error;
    } finally {
      // setLoading(false);
    }
  };

  const openEditScreen = (inspectionMasterId) => {
    const pathTemplate = "/client/:clientNameParam/inspection/:inspectionMasterId";
        const params = {
          clientNameParam: clientNameParam,
          inspectionMasterId: inspectionMasterId,
        };
    
        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
  };
  const openScheduleScreen = (inspectionMasterId) => {
     const pathTemplate = "/client/:clientNameParam/scheduleInspection/:inspectionMasterId";
        const params = {
          clientNameParam: clientNameParam,
          inspectionMasterId: inspectionMasterId,
        };
    
        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
  };
  const openAuditScreen = (inspectionMasterId,propertyMasterId) => {
     const pathTemplate = "/client/:clientNameParam/BookingHistory/:inspectionMasterId/:propertyMasterId";
        const params = {
          clientNameParam: clientNameParam,
          inspectionMasterId: inspectionMasterId,
          propertyMasterId: propertyMasterId
        };
    
        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
  };

  const handleDeleteinspection = async (inspectionMasterid) => {
    setButtonLoading(true);
    const payload = {
      inspectionIds: [inspectionMasterid],
      loggedInUserEmail: userObj?.userEmail,
    };
    // const params = new URLSearchParams();
    // payload.inspectionIds.forEach((id) => params.append("inspectionIds", id));
    // params.append("loggedInUserEmail", payload.loggedInUserEmail);

    // const queryString = params.toString();
    // console.log(queryString);
    // console.log(payload);
    try {
      //const response = await http.delete(DELETE_PROPERTY_INSPECTION, JSON.stringify(payload));
      //const response = await http.delete(DELETE_PROPERTY_INSPECTION + `?${query}`)
      const response = await http.delete(DELETE_PROPERTY_INSPECTION, {
        data: payload, // 👈 body goes in "data"
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Inspection has been deleted successfully.",
          });
        }, 1000);
        handleGetAllPropertyByClinetID(clientObj.clientId);
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting inspection, please try again.",
          });
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setButtonLoading(false);
      setShowConfirmationPopup(false);
      setPropertyToDelete({});
    }
  };

  useEffect(() => {
    if (allPropertyList) {
      const tempfilteredRows = allPropertyList?.filter((row) => {
        const matchesSearch =
          !toolbar.searchText ||
          row.propertyName
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.inspector
            ?.toLowerCase()
            .includes(toolbar.searchText.toLowerCase()) ||
          row.date?.toLowerCase().includes(toolbar.searchText.toLowerCase()) ||
          row.CreatedDate?.toLowerCase().includes(
            toolbar.searchText.toLowerCase()
          ) ||
          row.inspectionMasterId == toolbar.searchText ||
          row.status?.toLowerCase().includes(toolbar.searchText.toLowerCase());

        const matchesPropertyName =
          toolbar.propertyName === "Property Name" ||
          row.propertyName.toLowerCase() === toolbar.propertyName.toLowerCase();

        const matchesInspector =
          toolbar.inspector === "Inspector" ||
          row.inspector
            ?.toLowerCase()
            .includes(toolbar.inspector.toLowerCase());

        const matchesStatus =
          toolbar.status === "Status" || row.status === toolbar.status;

        const [day, month, year] = row.date.split("/");
        const rowDate = stripTime(`${year}-${month}-${day}`);
        const [day1, month1, year1] = row.CreatedDate.split("/");
        const creRowDate = stripTime(`${year1}-${month1}-${day1}`);
        const [start, end] = dateRange;

        const matchesDate =
          start === null ||
          end === null ||
          ((!start || rowDate >= stripTime(start)) &&
            (!end || rowDate <= stripTime(end))) ||
          ((!start || creRowDate >= stripTime(start)) &&
            (!end || creRowDate <= stripTime(end)));
        console.log(
          "date",
          dateRange,
          start,
          end,
          rowDate,
          matchesDate,
          creRowDate
        );

        return (
          matchesSearch &&
          matchesPropertyName &&
          matchesInspector &&
          matchesStatus &&
          matchesDate
        );
      });
      setFilteredRows(tempfilteredRows);
    } else {
      setFilteredRows(allPropertyList);
    }
  }, [allPropertyList, toolbar, dateRange]);
  const stripTime = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const tableColumns = [
    {
      field: "inspectionRefNumber",
      height: 50,
      width: 170,
      minWidth: 170,
      headerName: "Inspection ID",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "propertyName",
      height: 50,
      width: 200,
      minWidth: 200,
      headerName: "Property Name",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "date",
      width: 180,
      height: 50,
      headerName: "Approval Due Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "inspectionDate",
      width: 180,
      height: 50,
      headerName: "Inspection Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "inspector",
      height: 50,
      width: 220,
      minWidth: 220,
      headerName: "Assigned Inspector(s)",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      flex: 1,
      type: "string",
    },

    {
      field: "status",
      headerName: "Status",
      width: 150,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const status = params.value;

        const getChipStyle = (status) => {
          switch (status) {
            case Statuses.INPROGRESS:
              return {
                backgroundColor: "#FFA50033",
                color: "#CB8300",
                height: "20px",
              }; // orange

            case Statuses.SCHEDULED:
              return {
                backgroundColor: "#DBEAFE",
                color: "#081634",
                height: "20px",
              }; // blue
            case Statuses.COMPLETED:
              return {
                backgroundColor: "#DCFCE7",
                color: "#1B2C1B",
                height: "20px",
              }; // green
            case Statuses.SUBMITTEDFORAPPROVAL:
              return{
                backgroundColor: "#fff0b4",
                color: "#382f09ff",
                height: "20px",
              };
            case Statuses.REJECTED:
              return{
                backgroundColor: "#E520201A",
                color: "#E52020",
                height: "20px",
              };
            case Statuses.NEW:
              return{
                backgroundColor: "#dedbfe",
                color: "#54526bff",
                height: "20px",
              };
            default:
              return {
                backgroundColor: "#c3cac7ff",
                color: "#323a32ff",
                height: "20px",
              };
          }
        };
        return <Chip label={status} sx={getChipStyle(status)} />;
      },
    },
    {
      field: "CreatedDate",
      width: 160,
      height: 50,
      headerName: "Created Date",
      headerClassName: "super-app-theme--header",
      editable: false,
      filterable: true,
      sortable: true,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 220,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      filterable: true,
      type: "string",
      minWidth: 220,
      flex: 1,
      renderCell: (data) => {
        const isDisabled =
          data?.row?.status === Statuses.CANCELLED ? true : false;
        const isNew = data?.row?.status === Statuses.NEW ? true : false;  //hiding reschedule for prod --> || data?.row?.status === Statuses.SCHEDULED  ? true : false;
        const isCompleted = data?.row?.status === Statuses.COMPLETED ? true : false;
        return (
          <Box>
            <IconButton
              disabled={isDisabled || isCompleted}
              tabIndex={0}
              title="Edit Inspection"
              onClick={() => openEditScreen(data?.row?.inspectionMasterId)}
            >
              <EditOutlinedIcon sx={(isDisabled || isCompleted) ? {color: "#c3cac7ff"} : { color: "#EF3800" }} fontSize="small" />
            </IconButton>
            <IconButton
              disabled={isDisabled || !isNew}
              tabIndex={0}
              title="Schedule Inspection"
              onClick={() => openScheduleScreen(data?.row?.inspectionMasterId)}
            >
              <CalendarMonthOutlinedIcon
                sx={(isDisabled || !isNew) ? {color: "#c3cac7ff"} : { color: "#EF3800" }}
                fontSize="small"
              />
            </IconButton>
            <IconButton
              disabled={isDisabled || isCompleted}
              tabIndex={0}
              title="Delete Inspection"
              onClick={() => {
                setPropertyToDelete(data?.row);
                setShowConfirmationPopup(true);
              }}
            >
              <DeleteOutlineIcon sx={(isDisabled || isCompleted) ? {color: "#c3cac7ff"} : { color: "#EF3800" }} fontSize="small" />
            </IconButton>

               {/* <IconButton
              // disabled={isDisabled}
              tabIndex={0}
              title="Booking History"
              onClick={() => openAuditScreen(data?.row?.inspectionRefNumber,data?.row?.propertyMasterId)}
              >
              <HistoryIcon sx={ { color: "#EF3800" }} fontSize="small" />
            </IconButton> */}
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <ConfirmationPopup
        show={showConfirmationPopup}
        headingText="Delete Inspection"
        infoText={`Please confirm if you want to delete inspection for Property: ${propertyToDelete.propertyName}`}
        cancelText="Cancel"
        submitText={buttonLoading ? "Deleting..." : "Delete"}
        onCancel={() => {
          closePopup();
        }}
        onSubmit={() =>
          handleDeleteinspection(propertyToDelete.inspectionMasterId)
        }
      />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="p-2 border-0 w-100">
              <div
                className="dashboard_header dashboard_header_inspection d-flex"
                style={{ textAlign: "justify" }} //marginTop: "37px" }}
              >
                <div>
                  <h2 className="mb-0">Property Inspections</h2>
                  <p className="header-description">
                    Manage and track all property inspections
                  </p>
                </div>
                <div className="col-md-4 col-12 new-inspection-btn">
                  <button
                    className="btn btn-primary custom_toolbar_btn"
                    onClick={() => navigate(
                            generatePath("/client/:clientNameParam/inspection", {
                              clientNameParam,
                            })
                    )}
                  >
                    <i
                      className="fa fa-solid fa-plus"
                      style={{ paddingRight: "0.3rem" }}
                    ></i>
                    New Inspection
                  </button>
                </div>
              </div>

              <div className="row py-3 align-items-center g-3">
                {/* Search Bar */}
                <div className="custom_toolbar_search col-12 col-md-3 ">
                  <i className="fa-solid fa-magnifying-glass"></i>
                  <input
                    type="text"
                    className="form-control custom_toolbar_control"
                    id="floatingInput"
                    placeholder="Search"
                    value={toolbar.searchText}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, searchText: e.target.value })
                    }
                  />
                </div>

                {/* Dropdowns */}
                {/* <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.propertyName}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, propertyName: e.target.value })
                    }
                  >
                    <option value="Property Name">Property Name</option>
                    {[
                      ...new Set(
                        allPropertyList?.map((user) => user.propertyName)
                      ),
                    ].map((cityItem, index) => (
                      <option key={index} value={cityItem}>
                        {cityItem}
                      </option>
                    ))}
                  </select>
                </div> */}

                <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.inspector}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, inspector: e.target.value })
                    }
                  >
                    <option value="Inspector">Inspector</option>
                    {[...new Set(inspectorOptions)].map((cityItem, index) => (
                      <option key={index} value={cityItem}>
                        {cityItem}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-6 col-md-2">
                  <DatePicker
                    className=""
                    value={dateRange}
                    onChange={(range) => setDateRange(range || [null, null])}
                    range
                    format="YYYY-MM-DD"
                    placeholder="Select date range"
                    plugins={[
                      <Toolbar
                        key={1}
                        position="bottom"
                        sort={["deselect", "close", "today"]}
                      />,
                    ]}
                    style={{ width: "100%" }}
                  />
                </div>

                <div className="col-6 col-md-2">
                  <select
                    className="form-select custom_toolbar_control"
                    value={toolbar.status}
                    onChange={(e) =>
                      setToolBar({ ...toolbar, status: e.target.value })
                    }
                  >
                    <option value="Status">Status</option>
                    {[
                      ...new Set(allPropertyList?.map((user) => user.status)),
                    ].map((cityItem, index) => (
                      <option key={index} value={cityItem}>
                        {cityItem}
                      </option>
                    ))}
                  </select>
                </div>
                {isAnyFilterApplied && (
                <div style={{ width: "auto", paddingLeft: "0px" }}>
                  <IconButton
                    tabIndex={0}
                    title="Clear Filters"
                    onClick={() => {
                      setToolBar({
                        searchText: "",
                        propertyName: "Property Name",
                        inspector: "Inspector",
                        status: "Status",
                      });
                      setDateRange([null, null]);
                    }}
                  >
                    <ClearIcon sx={{ color: "#EF3800" }} fontSize="small" />
                  </IconButton>
                </div>
              )}

                {/* Export Button */}
                <div className="col-md-2 col-6 text-end ms-auto new-inspection-btn-toolbar">
                  <button
                    className="btn btn-primary custom_toolbar_btn"
                    onClick={() => navigate(
                      generatePath("/client/:clientNameParam/inspection", {
                              clientNameParam,
                            })
                    )}
                  >
                    <i
                      className="fa fa-solid fa-plus"
                      style={{ paddingRight: "0.3rem" }}
                    ></i>
                    New Inspection
                  </button>
                </div>
              </div>
              <div className="inspection-table">
                <NewDynamicTable
                  tableData={filteredRows}
                  columnsValue={tableColumns}
                  pageSize={10}
                  pageSizeOptions={[100, 150, 200, { value: -1, label: "All" }]}
                />
              </div>
              <div className="inspection-tile">
                {filteredRows &&
                  filteredRows?.map((item) => {
                    return (
                      // eslint-disable-next-line react/jsx-key
                      <InspectionTile
                        tableData={item}
                        openEditScreen={(itemid) => openEditScreen(itemid)}
                        openAuditScreen={(inspRef, propMaster) => openAuditScreen(inspRef, propMaster)}
                        openScheduleScreen={(itemid) =>
                          openScheduleScreen(itemid)
                        }
                        setPropertyToDelete={setPropertyToDelete}
                        setShowConfirmationPopup={setShowConfirmationPopup}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          <Footer />
<div className="bottom-bar-spacing"></div>
<BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default Inspections;
